import { PortalSettings } from '@Ravnur-Inc/shared/types/PortalSettings';
import genericRouteGuard from '@Ravnur-Inc/shared/route-guard/route-guard';
import acls from '@Ravnur-Inc/shared/helpers/acls';
import { instance as storeInstance } from '@/store';
import { UserPermissionsHelper } from '@Ravnur-Inc/shared/helpers/acls/permissions';

type LocalSettings = {
  isPrivatePortalAvailable?: boolean;
};

function routeGuard(
  settings?: Array<keyof (PortalSettings & LocalSettings)>,
  permissions?: Array<keyof UserPermissionsHelper>
) {
  return genericRouteGuard({
    settings: settings as Array<keyof PortalSettings>,
    permissions,
    getSettingsStore: () => {
      const base = acls.getApplicationSettings();
      return {
        ...(base as PortalSettings),
        isPrivatePortalAvailable: storeInstance.application.hasPrivatePortal,
      };
    },
    getPermissionsStore: () => acls.getUserPermissions(),
    getStoreInitializedField: () => storeInstance.user.isAuth,
  });
}

export default routeGuard;
